'use client';

import type { ReactNode } from 'react';
import { SignalsRenderer, parseSignalData } from './SignalsRenderer';
import type { HITLContentContext } from '../../tool-config-types';
import type { Signal } from './types';

export const renderSignalContent = (ctx: HITLContentContext): ReactNode => {
  // Convert extractedData to Signal[] format
  const signals: Signal[] = ctx.extractedData
    .map((item) => parseSignalData(item as Partial<Signal>))
    .filter((item): item is Signal => item !== null);

  if (signals.length === 0) return null;

  return (
    <SignalsRenderer
      signals={signals}
      maxHeight={ctx.maxHeight}
      variant="detailed"
    />
  );
};
